<template>
  <div>
    <success-dialog
      v-model="showSucessDialog"
      @input="$router.replace({ name: 'home' })"
    />
    <terms-dialog
      :show="showTermsDialog"
      :type="form.type"
      @close="onTermsDialogClose"
    />
    <v-layout align-center justify-center>
      <v-flex xs12 sm9 md8>
        <div class="text-xs-center">
          <template v-if="form.type === 'buyer'">
            <h1 class="ma-5">{{ $t("SIGNUP.BUYER_TITLE") }}</h1>
            <p class="mb-5">{{ $t("SIGNUP.BUYER_DESC") }}</p>
          </template>
          <template v-else>
            <h1 class="ma-5">{{ $t("SIGNUP.ARTIST_TITLE") }}</h1>
            <p class="mb-5">{{ $t("SIGNUP.ARTIST_DESC") }}</p>
          </template>
        </div>

        <v-radio-group v-model="form.type" row class="mb-3 justify-center">
          <v-radio :label="$tc('COMMON.BUYER')" value="buyer" color="primary" />
          <v-radio
            :label="$tc('COMMON.ARTIST')"
            value="artist"
            color="primary"
          />
        </v-radio-group>

        <v-form @submit.prevent="validateUser" autocomplete="off">
          <v-container>
            <v-layout row wrap>
              <!-- First name -->
              <v-flex sm6 xs12>
                <v-text-field
                  :error-messages="errors.first_name"
                  @focus="errors.first_name = null"
                  v-model="form.first_name"
                  :label="$t('SIGNUP.FIRST_NAME')"
                  required
                />
              </v-flex>
              <!-- Last name -->
              <v-flex sm6 xs12>
                <v-text-field
                  :error-messages="errors.last_name"
                  @focus="errors.last_name = null"
                  v-model="form.last_name"
                  :label="$t('SIGNUP.LAST_NAME')"
                  required
                />
              </v-flex>
              <!-- Email -->
              <v-flex sm6 xs12>
                <v-text-field
                  :error-messages="errors.email"
                  @focus="errors.email = null"
                  v-model="form.email"
                  :label="$t('COMMON.EMAIL')"
                  browser-autocomplete="off"
                  type="email"
                  required
                />
              </v-flex>
              <!-- Country -->
              <v-flex sm6 xs12>
                <tk-country-select
                  v-model="form.country_id"
                  :error-messages="errors.country_id"
                  @loading="(e) => (loading = e)"
                  @focus="errors.country_id = null"
                />
              </v-flex>
              <!-- Password -->
              <v-flex sm6 xs12>
                <v-text-field
                  :error-messages="errors.password"
                  @focus="errors.password = null"
                  v-model="form.password"
                  :label="$t('COMMON.PASSWORD')"
                  type="password"
                  browser-autocomplete="off"
                  required
                />

                <small>{{ $t("ACCOUNT.PASSWORD_REQUIREMENTS") }}</small>
              </v-flex>
              <!-- Repeat password -->
              <v-flex sm6 xs12>
                <v-text-field
                  v-model="form.password_confirmation"
                  autocomplete="new-password"
                  :label="$t('SIGNUP.REPEAT_PASSWORD')"
                  type="password"
                  required
                />
              </v-flex>

              <template v-if="form.type === 'artist'">
                <v-flex sm12>
                  <h3 class="mt-3">{{ $t("SIGNUP.ARTIST_SPECIFIC_INFO") }}</h3>
                </v-flex>
                <!-- Adress -->
                <v-flex sm12>
                  <v-text-field
                    :error-messages="errors.address"
                    @focus="errors.address = null"
                    v-model="form.address"
                    :label="$t('SIGNUP.ADDRESS')"
                    required
                  />
                </v-flex>
                <!-- Zip -->
                <v-flex sm6 xs12>
                  <v-text-field
                    :error-messages="errors.zip"
                    @focus="errors.zip = null"
                    v-model="form.zip"
                    :label="$t('SIGNUP.ZIP')"
                    required
                  />
                </v-flex>
                <!-- City -->
                <v-flex sm6 xs12>
                  <v-text-field
                    :error-messages="errors.city"
                    @focus="errors.city = null"
                    v-model="form.city"
                    :label="$t('SIGNUP.CITY')"
                    required
                  />
                </v-flex>
                <!-- Phone -->
                <v-flex sm6 xs12>
                  <v-text-field
                    :error-messages="errors.phone"
                    @focus="errors.phone = null"
                    v-model="form.phone"
                    :label="$t('SIGNUP.PHONE')"
                    type="tel"
                    required
                  />
                </v-flex>
                <!-- Birthday -->
                <v-flex sm6 xs12>
                  <v-menu
                    v-model="showBirthdayCalendar"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :label="$t('SIGNUP.BIRTHDAY')"
                        :error-messages="errors.birthday"
                        v-model="form.birthday"
                        @focus="errors.birthday = null"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="birthdayCalendar"
                      @input="showBirthdayCalendar = false"
                    />
                  </v-menu>
                </v-flex>
                <!-- Profession -->
                <v-flex sm12>
                  <div class="pb-3">
                    <h3>{{ $t("SIGNUP.PROFESSION") }}</h3>
                    <v-layout wrap>
                      <v-flex
                        ma-0
                        pa-0
                        xs6
                        sm4
                        v-for="profession in professions"
                        :key="profession.id"
                      >
                        <v-checkbox
                          class="mt-2"
                          v-model="form.professions"
                          :label="profession.name"
                          :value="profession.id"
                          color="primary"
                          hide-details
                        />
                      </v-flex>
                    </v-layout>
                    <div class="mt-2" v-if="errors.professions">
                      <p
                        v-for="e in errors.professions"
                        :key="e"
                        class="ma-0 pa-0 red--text"
                      >
                        {{ e }}
                      </p>
                    </div>
                  </div>
                </v-flex>
                <!-- Members -->
                <v-flex sm12>
                  <div class="mt-1 mb-3">
                    <h3>{{ $t("SIGNUP.MEMBER_ASSOC") }}</h3>
                    <v-checkbox
                      class="mt-2"
                      color="primary"
                      v-for="assoc in associations"
                      v-model="form.associations"
                      :key="assoc.id"
                      :label="assoc.name"
                      :value="assoc.id"
                      hide-details
                    />
                    <div class="mt-2" v-if="errors.associations">
                      <p
                        v-for="e in errors.associations"
                        :key="e"
                        class="ma-0 pa-0 red--text"
                      >
                        {{ e }}
                      </p>
                    </div>
                  </div>
                </v-flex>
                <!-- Finnish artist assoc -->
                <v-flex sm12>
                  <div class="mb-3">
                    <h3>{{ $t("SIGNUP.MEMBER_FINNISH_ARTISTS_ASSOC") }}</h3>
                    <v-radio-group
                      v-model="form.finnish_artists_assoc"
                      row
                      class="mt-2"
                      :error-messages="errors.finnish_artists_assoc"
                    >
                      <v-radio
                        :label="$tc('COMMON.YES')"
                        :value="true"
                        color="primary"
                      />
                      <v-radio
                        :label="$tc('COMMON.NO')"
                        :value="false"
                        color="primary"
                      />
                    </v-radio-group>
                  </div>
                </v-flex>
              </template>

              <!-- Newsletter -->
              <v-flex sm6 xs12>
                <v-checkbox
                  class="mt-2"
                  v-model="form.newsletter"
                  :label="$t('COMMON.NEWSLETTER_SUBSCRIBE')"
                  color="primary"
                  hide-details
                />
              </v-flex>
              <!-- Submit btn -->
              <v-flex sm6 xs12 text-xs-right>
                <tk-btn
                  :loading="pending"
                  :disabled="loading"
                  type="submit"
                  color="primary"
                  >{{ $t("COMMON.SUBMIT") }}</tk-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";

const usersRepo = RepositoryFactory.users();
const translationsRepo = RepositoryFactory.translations();
const handler = new ErrorHandler();

export default {
  components: {
    TermsDialog: () => import("@/components/terms/TermsDialog.vue"),
    SuccessDialog: () => import("./SuccessDialog.vue"),
    TkCountrySelect: () => import("@/components/core/TkCountrySelect.vue"),
  },

  data() {
    return {
      showBirthdayCalendar: false,
      birthdayCalendar: null,
      showTermsDialog: false,
      showSucessDialog: false,
      loading: false,
      pending: false,
      associations: [],
      professions: [],
      form: {
        type: "buyer",
        associations: [],
        professions: [],
        term_id: null,
      },
      errors: {},
    };
  },

  watch: {
    "form.type": function (val) {
      if (val === "artist") {
        this.form.newsletter = true;
        this.form.associations = [];
        this.form.professions = [];
      }
    },
    birthdayCalendar: function (val) {
      const [year, month, day] = val.split("-");
      this.form.birthday = `${day}/${month}/${year}`;
    },
  },

  created() {
    this.getTranslations();
  },

  methods: {
    async validateUser() {
      this.errors = {};
      this.pending = true;
      try {
        this.preparePayload();
        await usersRepo.validate(this.form);
        this.showTermsDialog = true;
      } catch (error) {
        this.catchValidationError(error);
      }
      this.pending = false;
    },

    async submit() {
      this.pending = true;
      try {
        this.preparePayload();
        const res = await usersRepo.register(this.form);
        this.showSucessDialog = true;
      } catch (error) {
        this.catchValidationError(error);
      }

      this.pending = false;
    },

    catchValidationError(error) {
      if (error.status === 422 && error.data) {
        this.errors = error.data.errors;
      }
    },

    async getTranslations() {
      this.loading = true;
      await handler.handle(async () => {
        const res = await translationsRepo.getTranslations(
          "associations,professions"
        );
        this.professions = res.professions;
        this.associations = res.associations;
      });
      this.loading = false;
    },

    onTermsDialogClose(termId) {
      this.showTermsDialog = false;
      this.form.term_id = null;
      if (termId) {
        this.form.term_id = termId;
        this.submit();
      }
    },

    preparePayload() {
      if (this.form.type === "buyer") {
        delete this.form.associations;
        delete this.form.professions;
      }
    },
  },
};
</script>
